import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { get, isEmpty } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import {
  FlexBox,
  DoconCard,
  Icons,
} from '@docon/docon-ui-library';
import DocItem from './DocItem';
import OtherNumbers from 'components/DoctorProfile/OtherNumbers';
import BookAppointmentModal from 'components/BookAppointment';
import { getClinics } from 'redux/reducer/doctor';
import { AppointmentBookIcon, ProfileIcon } from 'shared/icons';
import { borderColor, colors } from 'utilities/colorConfig';
import { cleverTapAnl } from 'utilities';
import { EventBookAppointment } from 'utilities/clevertapEvent';

const FooterItem = styled(FlexBox)`
  flex: 1;
  gap: 8px;
  padding: 12px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  color: ${colors.primaryBlue};
  text-transform: uppercase;

  &:first-child {
    border-right: 1px solid ${borderColor};
  }

  :hover {
    background: ${colors.whitesmokeColor};
  }
`;

const Root = styled(DoconCard)`
  padding: 0;
  cursor: pointer;
  overflow: hidden;

  :hover {
    box-shadow: 0px 4px 12px rgba(0, 41, 77, 0.25);
  }

  .docItem { border-bottom: 1px solid ${borderColor}; }

  & + & {
    margin-top: 1rem;
  }

  ${({ $hasShortUrl }) => !$hasShortUrl && css`
    pointer-events: none;

    .docItem { border-color: transparent; }
  `}
`;

function Card({
  rank,
  pageName,
  doctor = {},
  onClick,
}: any) {

  const { clinicsByDocId } = useSelector(state => state.doctor);
  const [showMobileNumber, setShowMobileNumber] = useState(false);
  const [openBookingModal, setOpenBookingModal] = useState<any>(false);
  const clinics = clinicsByDocId[doctor.doctorID] || [];
  const dispatch = useDispatch();

  useEffect(() => {
    if (doctor?.visibility !== 'on' && isEmpty(clinics) || !doctor.clinicID)
      dispatch(getClinics(doctor.doctorID));
  }, []);

  function handleClick(event: any) {
    if (showMobileNumber || openBookingModal) return;

    event.stopPropagation();
    const id = event?.currentTarget?.id;
    switch (id) {
      case 'appointment':
        if (doctor?.visibility !== 'on')
          return setShowMobileNumber(true);
        else {
          cleverTapAnl.event({
            event_name: 'book_appointment',
            event: {
              page_name: pageName,
              doctor_id: doctor.doctorID,
            },
          } as EventBookAppointment);
          setOpenBookingModal(true);
        }
        break;

      default:
        return doctor.shortUrl && onClick({ rank, ...doctor });
    }
  }

  const handleModalClose = (modal: string) => () => {
    switch (modal) {
      case 'otherNumbers':
        return setShowMobileNumber(false);
      case 'appointmentBooking':
        return setOpenBookingModal(false);
      default:
        break;
    }
  };

  const hasShortUrl = !!doctor.shortUrl;
  const clinicID = doctor.clinicID || get(clinics, '0.clinicID');
  return (
    <Root onClick={handleClick} $hasShortUrl={hasShortUrl}>
      {
        showMobileNumber ? (
          <OtherNumbers
            isOpen
            clinics={clinics}
            onClose={handleModalClose('otherNumbers')}
          />
        ) : null
      }

      {
        openBookingModal ? (
          <BookAppointmentModal
            isOpen
            doctor={{ clinicID, ...doctor }}
            onClose={handleModalClose('appointmentBooking')}
          />
        ) : null
      }

      <DocItem className='docItem' doctor={doctor} />

      <FlexBox hidden={!hasShortUrl}>
        <FooterItem id='appointment' onClick={handleClick}>
          {
            doctor?.visibility == 'on' ? (
              <>
                <AppointmentBookIcon /> Book
              </>
            ) : (
              <>
                <Icons.PhoneIcon /> Call
              </>
            )
          }
        </FooterItem>
        <FooterItem id='profile' onClick={handleClick}>
          <ProfileIcon /> Profile
        </FooterItem>
      </FlexBox>
    </Root>
  );
}

export default Card;

